import { LoadingState } from '../../../../types/loading-state';
import { compactMap } from '../../../../utils/array-utils';
import { createFetchedData } from '../../../../utils/fetched-data/create-fetched-data';
import { getFetchedDataPayload } from '../../../../utils/fetched-data/get-fetched-data-payload';
import { getFilterByIdAndType } from '../../../filter/selectors/get-filter-by-id-and-type';
import { FilterType } from '../../../filter/types/filter-type';
import { filterShowtimes } from '../../../filter/utils/filter-showtimes';
import { browsingDomainStore } from '../../store';
import { getShowtimeById } from './get-showtime-by-id';
export const getShowtimesForEvent = (eventId, siteId, filterId) => {
    const showtimeIdsData = getEventShowtimeIdsForSite(eventId, siteId);
    const showtimeIds = getFetchedDataPayload(showtimeIdsData) || [];
    const showtimes = compactMap(showtimeIds, showtimeId => getShowtimeById(showtimeId));
    const filter = filterId ? getFilterByIdAndType(filterId, FilterType.Showtime) : undefined;
    return filter ? filterShowtimes(filter, showtimes) : showtimes;
};
const getEventShowtimeIdsForSite = (eventId, siteId) => {
    var _a;
    const showtimeIdsData = (_a = browsingDomainStore.data.showtimeIdsForEventBySite[siteId]) === null || _a === void 0 ? void 0 : _a[eventId];
    return showtimeIdsData || createFetchedData(LoadingState.NotLoaded);
};
